import script from "./AppSettingsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSettingsPanel.vue?vue&type=script&setup=true&lang=js"

import "./AppSettingsPanel.vue?vue&type=style&index=0&id=8b73ef68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b73ef68"]])

export default __exports__